
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RepairRequestService } from 'src/app/services/repair-request.service';

@Component({
    selector: 'payback',
    templateUrl: 'payback.component.html'
})

export class PaybackComponent implements OnInit {
    authority: string = '';
    status: string = '';
    message: string = '';

    constructor(private route: ActivatedRoute, private repairService: RepairRequestService) { }

    ngOnInit() { 
        this.authority = this.route.snapshot.queryParamMap.get('Authority');
        this.status = this.route.snapshot.queryParamMap.get('Status');
        //window.history.pushState({}, document.title, window.location.origin + window.location.pathname);

        console.log('authority: ', this.authority);
        console.log('status: ', this.status);

        if (this.status == 'OK') {
            this.repairService.verifyPayment(this.authority).subscribe((resp: any) => {
                this.message = resp.message;
            }, err => {
                console.error('payment error: ', err);
                this.message = 'پرداخت ناموفق';
            });
        }
        else {
            this.message = 'پرداخت ناموفق.';
        }

    }
}